const isSeonEnabled = process.env.REACT_APP_SEON_ENABLED === 'true'

/**
 * Initializes the SEON SDK for device fingerprinting / analytics.
 * Safe to call when SEON is disabled or unavailable.
 */
export const initiateSeon = () => {
  try {
    if (!isSeonEnabled || typeof window === 'undefined' || typeof window?.seon?.init !== 'function') {
      return
    }

    window.seon.init()
  } catch (err) {
    console.error('Error initiating seon:', err)
  }
}

/**
 * Returns the SEON encrypted device fingerprint session string.
 * Safe to call when SEON is disabled or unavailable — returns an empty string so API calls can still proceed.
 */
export const getSeonSession = async () => {
  try {
    if (!isSeonEnabled || typeof window === 'undefined' || typeof window?.seon?.getSession !== 'function') {
      return ''
    }

    const session = await window.seon.getSession()
    return session || ''
  } catch (err) {
    console.error('Error getting SEON session:', err)
    return ''
  }
}
